import { Box, Chip, Fade, Typography } from "@mui/material";
import React, { useEffect } from "react";
import { useTranslation } from 'react-i18next';

const PipelineStages = ({stagePipeline, selectStage, stages = [], loaded, setNextDisabled}) => {
    const { t } = useTranslation();

    useEffect(() => {
        loaded();
    }, []);

    const activeIndex = stages.findIndex(s => s.id === stagePipeline?.id);

    if (stages.length === 0) return null;

    return (
        <Fade in timeout={300}>
            <Box sx={{ width: '100%' }}>
                <Typography variant="subtitle2" sx={{ color: 'rgba(255,255,255,0.7)', mb: 1, fontWeight: 600 }}>
                    {t('pipelineStages')} *
                </Typography>
                <Box sx={{
                    display: 'flex', gap: 1, overflowX: 'auto',
                    WebkitOverflowScrolling: 'touch', pb: 0.5,
                    '&::-webkit-scrollbar': { display: 'none' },
                    scrollbarWidth: 'none',
                }} data-testid="stage-radio-group">
                    {stages.map((s, i) => {
                        const isActive = s.id === stagePipeline?.id;
                        const isPast = activeIndex >= 0 && i < activeIndex;

                        return (
                            <Chip key={s.id} label={s.label}
                                data-testid={`stage-option-${s.id}`}
                                onClick={() => {
                                    setNextDisabled(false);
                                    selectStage({
                                        id: s.id,
                                        name: s.label
                                    }, false);
                                }}
                                sx={{
                                    height: 44, borderRadius: '12px', minWidth: 80,
                                    fontWeight: isActive ? 700 : isPast ? 500 : 400,
                                    fontSize: '0.8125rem',
                                    backgroundColor: isActive
                                        ? '#1f7a7a'
                                        : isPast
                                            ? 'rgba(31,122,122,0.2)'
                                            : 'rgba(255,255,255,0.06)',
                                    color: isActive
                                        ? '#fff'
                                        : isPast
                                            ? '#7cb7b7'
                                            : 'rgba(255,255,255,0.85)',
                                    border: isActive
                                        ? '2px solid #1f7a7a'
                                        : isPast
                                            ? '1px solid rgba(31,122,122,0.5)'
                                            : '1px solid rgba(255,255,255,0.3)',
                                    boxShadow: isActive ? '0 0 16px rgba(31,122,122,0.35)' : 'none',
                                    transition: 'all 0.25s ease',
                                    '&:hover': {
                                        backgroundColor: isActive
                                            ? '#176b6b'
                                            : 'rgba(255,255,255,0.12)',
                                    },
                                    flexShrink: 0,
                                }}
                            />
                        );
                    })}
                </Box>
            </Box>
        </Fade>
    );
}

export default PipelineStages;
